const moduleRoute = {
  path: '/serm',
  component: () => import('../Module.vue'),
  children: [
    {
      path: '/serm',
      name: 'sermMediaplan',
      component: () => import('../views/Mediaplan.vue')
    },
    {
      path: '/serm/kpi',
      name: 'sermKPI',
      component: () => import('../views/KPI.vue')
    },
    {
      path: '/serm/timeline',
      name: 'sermTimeline',
      component: () => import('../views/Timeline.vue')
    },
    {
      path: '/serm/analytics',
      name: 'sermAnalytics',
      component: () => import('../views/Analytics.vue')
    },
    {
      path: '/serm/reviews',
      name: 'sermReviews',
      component: () => import('../views/Reviews.vue')
    },
    {
      path: '/serm/monitoring',
      name: 'sermMonitoring',
      component: () => import('../views/Monitoring.vue')
    },
    {
      path: '/serm/report',
      name: 'sermReport',
      component: () => import('../views/Reports.vue')
    }
  ]
}

export default router => {
  router.addRoutes([moduleRoute])
}
